import type { Status } from "@/types";

const STYLES: Record<Status, { label: string; bg: string }> = {
  building: { label: "Building", bg: "#9CC9E8" },
  draft: { label: "Needs work", bg: "#FFFFFF" },
  in_review: { label: "To review", bg: "#F6D776" },
  approved: { label: "Approved", bg: "#B9E3C6" },
  publishing: { label: "Publishing", bg: "#9CC9E8" },
  sent: { label: "Etsy draft", bg: "#23324A" },
};

export function StatusPill({ status, testId }: { status: Status; testId?: string }) {
  const s = STYLES[status] || STYLES.draft;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-full border-2 border-[#23324A] px-2.5 py-0.5 text-xs font-bold ${status === "sent" ? "text-white" : "text-[#23324A]"}`}
      style={{ background: s.bg }}
    >
      {status === "building" && <span className="h-2 w-2 animate-pulse rounded-full bg-[#23324A]" />}
      {s.label}
    </span>
  );
}
